import { Component, OnInit } from '@angular/core';
// import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFireAuth } from "@angular/fire/auth";
import { environment } from '../../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { AlertaExportarDialog } from '../dialogs/exportar-dialog/exportar-dialog';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { ProdutoConsultaElement } from '../../interfaces/produtos.consulta';

import { ExcelService } from '../../services/excel.service';
import { ProdutoEstoqueConsulta } from 'src/app/interfaces/produtos.estoque';
// import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';

@Component({
  selector: 'app-relatorio-estoque',
  templateUrl: './relatorio-estoque.component.html',
  styleUrls: ['./relatorio-estoque.component.scss', '../../styles/estilo.padrao.scss']
})

export class RelatorioEstoqueComponent implements OnInit {
  uid;
  tipoCadastro = 'Vendedor';
  bExportar: boolean = false;
  produtos: Array<ProdutoConsultaElement>;

  sbBuscaTipoRelatorio: string = 'Completo';
  aTipoTipoBuscaRelatorio: any[] = [
    { value: 'Completo', name: 'Completo' },
    { value: 'Alerta estoque mínimo', name: 'Alerta estoque mínimo' },
  ];

  constructor(
    // private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private af: AngularFireAuth,
    private dialog: MatDialog,
    private excelService: ExcelService,
  ) {
    this.uid = localStorage.getItem('uid');

    this.af.authState.subscribe(snap => {
      this.uid = snap.uid;

      if (this.uid !== environment.idCliente) {
        this.tipoCadastro = 'Vendedor';
      } else
        this.tipoCadastro = 'Admin';
    });
  }

  ngOnInit(): void {
  }

  async gerarRelatorio() {

    this.spinner.show('relatorio-estoque');

    const estoques = await this.usuarioService.getEstoquesProdutos();

    this.usuarioService.getProdutos().pipe(take(1)).subscribe(snap => {

      if (snap.length > 0) {
        var dados;
        let auxProdutosSource: ProdutoConsultaElement[] = [];

        snap.forEach((item, index) => {
          dados = item.payload.val();

          dados.QuantidadeEstoque = estoques.find(x => x.ID === item.key)?.QuantidadeEstoque || 0;

          if (this.validarFiltro(this.sbBuscaTipoRelatorio, dados)) {
            auxProdutosSource.push({
              ID: item.key,
              Status: dados.Status ? 'Ativo' : 'Desativado',
              URL_Imagem: dados.URL_Imagem,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro),
              //Parte 1
              TipoItem: dados.TipoItem,
              Unidade: dados.Unidade,
              IDUnidade: dados.IDUnidade,
              Nome: dados.Nome,
              NomeBusca: dados.NomeBusca,
              Grupo: dados.Grupo,
              IDGrupo: dados.IDGrupo,
              IDFornecedorPreferencial: dados.IDFornecedorPreferencial,
              CodigoBarras: dados.CodigoBarras,
              DescricaoComplementar: dados.DescricaoComplementar,
              Referencia: dados.Referencia,
              //Parte 2
              Valor: dados.Valor,
              ValorString: 'R$ ' + (dados.Valor).toFixed(2).replace('.', ','),
              ValorAtacado: dados.ValorAtacado,
              QuantidadeAtacado: dados.QuantidadeAtacado,
              QuantidadeEstoque: dados.QuantidadeEstoque, // Valor inserido com base na nova tabela de estoque
              QuantidadeMinimaAlertaEstoque: dados.QuantidadeMinimaAlertaEstoque,
              QuantidadeMinima: dados.QuantidadeMinima,
              QuantidadeMaxima: dados.QuantidadeMaxima,
              Identificador: dados.Identificador,
              CodigoProduto: dados.CodigoProduto, // Fazer em função em nuvem ou cadastro posterior
              LucroBruto: dados.LucroBruto,
              Comissao: dados.Comissao,
              CustoCompra: dados.CustoCompra,
              CustoMedio: dados.CustoMedio,
              //Parte 5
              ValorPromocional: dados.ValorPromocional,
              TimestampInicialPromocional: dados.TimestampInicialPromocional,
              TimestampFinalPromocional: dados.TimestampFinalPromocional,
              //Demais parâmetros
              TimestampCadastro: dados.TimestampCadastro
            });
          }

          this.produtos = auxProdutosSource.sort((a, b) => a.Nome.localeCompare(b.Nome));

          this.bExportar = true;

          setTimeout(() => this.spinner.hide('relatorio-estoque'), 300);
        });
      }
    });
  }

  validarFiltro(tipo, produto) {
    switch (tipo) {
      case 'Completo':
        return true;

      case 'Alerta estoque mínimo':
        return produto.QuantidadeMinimaAlertaEstoque >= produto.QuantidadeEstoque;

      default: return false;
    }
  }

  exportar() {
    const dialogRef = this.dialog.open(AlertaExportarDialog, {
      data: { bPDF: true, bExcel: true, bCSV: false },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo)
      }
    });
  }

  imprimir(tipo) {
    var date = new Date();

    switch (tipo) {
      //PDF
      case 0:
        let doc = new jsPDF('l', 'mm', [297, 210]);
        let corpo: any = [];
        this.produtos.forEach(dado => {
          var aux = [dado.CodigoProduto, dado.Nome, dado.Grupo, dado.QuantidadeMinimaAlertaEstoque, dado.QuantidadeEstoque, dado.ValorString, dado.Status];
          corpo.push(aux);
        });

        autoTable(doc, {
          head: [["Código", "Nome", "Grupo", "Qnt. Min. Alerta", "Qnt. Estoque", "Valor", "Status"]],
          theme: 'grid',
          body: corpo,
          margin: { top: 10, right: 5, bottom: 10, left: 5 },
          showHead: 'firstPage',
          showFoot: 'lastPage',
          foot: [["", "", "", "", "", "", ""]]
        });
        doc.save('Relatório_de_estoque_' + this.usuarioService.tratarData(date.getTime()) + '.pdf');

        this.usuarioService.setLog("Exportou relatório de estoque em PDF. Data: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);
        break;

      //Excel
      case 1:
        this.excelService.exportAsExcelFile(this.produtos, 'Relatório_de_estoque_' + this.usuarioService.tratarData(date.getTime()));

        this.usuarioService.setLog("Exportou relatório de estoque em EXCEL. Data: " + this.usuarioService.tratarData(date.getTime()), null, this.uid);
        break;

      //CSV
      // case 2:
      //   var options = {
      //     fieldSeparator: ',',
      //     quoteStrings: '"',
      //     decimalseparator: '.',
      //     showLabels: true,
      //     showTitle: true,
      //     title: 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()),
      //     useBom: true,
      //     noDownload: false,
      //     headers: ["ID", "Status", "Bandeira cartão", "CEP", "Cidade", "Complemento", "Email", "Forma de pagamento", "IDVendedor", "Logradouro", "Nome", "Numero", "Observacao", "Referencia", "Status", "Status do pagamento", "Telefone", "Telefone secundário", "Total", "UF", "Data", "Hora", "Data da separação", "Hora da separação", "Data da rota", "Hora da rota", "Data da entrega", "Hora da entrega", "Data do cancelamento", "Hora do cancelamento", "Motivo do cancelamento", "Data e hora do pagamento"],
      //     nullToEmptyString: true,
      //   };

      //   new Angular5Csv(this.auxPedidos, 'Relatório_' + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), options);
      //   this.usuarioService.setLog("Exportou relatório de vendas em CSV. Período: " + this.usuarioService.tratarData(date.getTime()) + "_" + this.usuarioService.tratarData(dateFinal.getTime()), map, this.uid);

      //   break;
    }
  }

}
